export interface Example {
  id: string;
  label: string;
  text: string;
}

// Source: https://github.com/xdward/mini-dafny/blob/main/tests/integration.rs
// Preserve upstream names (including ASSIGN_O) and program text.
export const examples: readonly Example[] = [
  {
    id: "assign_o",
    label: "ASSIGN_O",
    text: "var x\nassume x >= 0\nx := x + 1\nassert x >= 1\n",
  },
  {
    id: "assign_1",
    label: "ASSIGN_1",
    text: "var x\nassume x >= 0\nx := x - 1\nassert x >= 1\n",
  },
  {
    id: "assign_2",
    label: "ASSIGN_2",
    text: "var i, j\nassume i > j\ni := i + 1\nj := j + 1\nassert i > j + 1\n",
  },
  {
    id: "assign_3",
    label: "ASSIGN_3",
    text: "var x\nassume (x + 3) * 2 > 6\nx := x + 3\nx := x * 2\nassert x >= 6\n",
  },
  {
    id: "assign_4",
    label: "ASSIGN_4",
    text: "var a, b, t\nt := a\na := b\nb := t\nassert a == b\n",
  },
  {
    id: "if_0",
    label: "IF_0",
    text: "var x, y\nif x > 0 then\n    y := x\nelse\n    y := 1\nend\nassert y > 0\n",
  },
  {
    id: "if_1",
    label: "IF_1",
    text: "var x, y\nassume x >= 0\nif x > 0 then\n    y := x\nelse\n    y := 0\nend\nassert y > 0\n",
  },
  {
    id: "if_2",
    label: "IF_2",
    text: "var x, y\nassume x >= 0\nif x > y then\n    y := x\nend\nassert y >= x\n",
  },
  {
    id: "loop_to_0",
    label: "LOOP_TO_0",
    text: "var i, n\nassume  0 < n\ni := n\nwhile 0 < i\ninvariant i <= n && i >= 0\n    i := i - 1\nend\nassert i == 0\nassert i <= n\n",
  },
  {
    id: "loop_to_1",
    label: "LOOP_TO_1",
    text: "var i, n\nassume 0 < n\ni := n\nwhile 0 < i\ninvariant i <= n && i <= 0\n    i := i - 1\nend\nassert i > 0\n",
  },
  {
    id: "max3_0",
    label: "MAX3_0",
    text: "var a, b, c, m\nif a >= b then\n    m := a\nelse\n    m := b\nend\nif c >= m then\n    m := c\nend\nassert m >= a && m >= b && m >= c\nassert m == a || m == b || m == c\n",
  },
  {
    id: "max3_1",
    label: "MAX3_1",
    text: "var a, b, c, m\nif a >= b then\n    m := a\nelse\n    m := b\nend\nif c > m then\n    m := c + 1\nend\nassert m >= a && m >= b && m >= c\nassert m == a || m == c || m == c\n",
  },
  {
    id: "max3_2",
    label: "MAX3_2",
    text: "var a, b, c, m\nif a >= b then\n    m := a\nelse\n    m := b\nend\nif c > m then\n    m := c + 1\nend\nassert m >= a && m >= b && m >= c\n",
  },
  {
    id: "max3_3",
    label: "MAX3_3",
    text: "var a, b, c, m\nif a >= b then\n    m := a\nelse\n    m := b\nend\nassert m >= a && m >= b && m >= c\nassert m == a || m == b || m == c\n",
  },
  {
    id: "skip_0",
    label: "SKIP_0",
    text: "var x\nassume x >= 0\nassert x >= 0\n",
  },
  {
    id: "skip_1",
    label: "SKIP_1",
    text: "var x\nassume x >= 0\nassert x == 0\n",
  },
  {
    id: "slow_copy_0",
    label: "SLOW_COPY_0",
    text: "var x, y, inp, out\nassume 0 <= inp\nx := inp\ny := 0\nwhile 0 < x\ninvariant x >= 0 && y + x == inp\n    x := x - 1\n    y := y + 1\nend\nout := y\nassert out == inp\n",
  },
  {
    id: "slow_copy_1",
    label: "SLOW_COPY_1",
    text: "var x, y, inp, out\nassume 0 <= inp\nx := inp\ny := 0\nwhile 0 < x\ninvariant TRUE\n    x := x - 1\n    y := y + 1\nend\nassert out == inp\n",
  },
  {
    id: "slow_copy_2",
    label: "SLOW_COPY_2",
    text: "var x, y, inp, out\nassume 0 <= inp\nx := inp\ny := 0\nwhile 0 < x\ninvariant x >= 0 && y + x == inp\n    x := x - 1\n    y := y + 2\nend\nout := y\nassert out == inp\n",
  },
  {
    id: "slow_square_0",
    label: "SLOW_SQUARE_0",
    text: "var a, i, n\nassume 0 <= n\na := 0\ni := 0\nwhile i < n\ninvariant i <= n && a == n * i\n    i := i + 1\n    a := a + n\nend\nassert a == n * n\n",
  },
  {
    id: "slow_square_1",
    label: "SLOW_SQUARE_1",
    text: "var a, i, n\nassume 0 <= n\na := 0\ni := 0\nwhile i < n\ninvariant a == n * i\n    i := i + 1\n    a := a + n\nend\nassert a == n * n\n",
  },
  {
    id: "swap_0",
    label: "SWAP_0",
    text: "var a, b, t\nif b < a then\n    t := a\n    a := b\n    b := t\nend\nassert a <= b\n",
  },
  {
    id: "swap_1",
    label: "SWAP_1",
    text: "var a, b, t\nif b < a then\n    t := a\n    a := t\nend\nassert a <= b\n",
  },
];
